
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <div className="text-2xl font-light text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Healing Paw Vet
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              홈
            </Link>
            <Link 
              to="/about" 
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/about') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              홉 CBD란
            </Link>
            <Link 
              to="/cases" 
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/cases') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              반려동물 케이스
            </Link>
            <Link 
              to="/science" 
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/science') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              연구 & 안전성
            </Link>
            <Link 
              to="/faq" 
              className={`text-sm transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/faq') ? 'text-gray-900 font-medium' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              FAQ & 문의
            </Link>
          </nav>

          <a 
            href="https://smartstore.naver.com/hops_cbd/products/11927710702"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:block px-6 py-2 bg-gray-900 text-white text-sm hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            상품 구매하기
          </a>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-6 py-6 space-y-4">
            <Link 
              to="/" 
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-sm transition-colors cursor-pointer ${
                isActive('/') ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              홈
            </Link>
            <Link 
              to="/about" 
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-sm transition-colors cursor-pointer ${
                isActive('/about') ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              홉 CBD란
            </Link>
            <Link 
              to="/cases" 
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-sm transition-colors cursor-pointer ${
                isActive('/cases') ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              반려동물 케이스
            </Link>
            <Link 
              to="/science" 
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-sm transition-colors cursor-pointer ${
                isActive('/science') ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              연구 & 안전성
            </Link>
            <Link 
              to="/faq" 
              onClick={() => setMobileMenuOpen(false)}
              className={`block text-sm transition-colors cursor-pointer ${
                isActive('/faq') ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              FAQ & 문의
            </Link>
            <a 
              href="https://smartstore.naver.com/hops_cbd/products/11927710702"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full px-6 py-3 bg-gray-900 text-white text-sm hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center"
            >
              상품 구매하기
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
